import { Injectable } from '@angular/core';
import { initializeApp, FirebaseApp } from "firebase/app";
import {
  getAuth,
  onAuthStateChanged,
  connectAuthEmulator,
  Auth,
  User,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  signInWithEmailAndPassword,
  ConfirmationResult,
  sendPasswordResetEmail,
  UserCredential} from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FunctionsService } from '../data/functions.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  app: FirebaseApp;
  auth: Auth;
  user: User;
  recaptchaVerifier: any;
  profile: any
  applicationInitialized =  false

  constructor(
    private functions: FunctionsService
  ) {}

  initApp() {
    this.app = initializeApp(environment.firebaseConfig);
    this.auth = getAuth(this.app);
    this.auth.languageCode = 'pt-BR';

    // Modo OFFLINE (build `offline`): esta instância de Auth — usada na
    // verificação por telefone (signInWithPhoneNumber) — precisa apontar para o
    // EMULADOR, senão o SMS/reCAPTCHA vai para o Firebase real e falha (400 em
    // accounts:sendVerificationCode). `appVerificationDisabledForTesting` desliga
    // o reCAPTCHA: o emulador gera o código sem enviar SMS (visível na UI do
    // emulador). Em dev/staging/prod `useEmulators` é undefined -> nada muda.
    if ((environment as any).useEmulators) {
      connectAuthEmulator(this.auth, (environment as any).emulators.auth.url, { disableWarnings: true });
      this.auth.settings.appVerificationDisabledForTesting = true;

      // Conecta o Firestore DESTA MESMA instância (this.app) ao emulador. A
      // vitrine/home lê Firestore direto via getFirestore(this.firebase.app); sem
      // isto essas leituras caem no Firestore de PRODUÇÃO (catálogo online mesmo
      // offline). O try/catch cobre o caso de a instância já ter sido conectada
      // pela factory provideFirebaseApp do app.module (dupla conexão lança erro).
      try {
        const emu = (environment as any).emulators;
        connectFirestoreEmulator(getFirestore(this.app), emu.firestore.host, emu.firestore.port);
      } catch (e) {
        console.warn('[firebase] Firestore emulator já conectado nesta instância:', e);
      }
    }

    onAuthStateChanged(this.auth, (user) => {
      if (user) {
        this.user = user;
        this.user.getIdToken(true).then(token => {
          this.entrar(token);
          this.functions.profile()
          .subscribe(
            {
              next: resp => {
                this.profile = resp.body.data;
              },
              error: (error) => console.error
            }
          )

        }).catch(error => {
          console.error(error);
        }).finally(() => {
          this.applicationInitialized = true;
        })

      } else {
        this.user = null;
        localStorage.clear();
        this.applicationInitialized = true;
      }
    });
  }

  entrarComTelefone(telefone: string):  Promise<ConfirmationResult>{
    this.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
      size: 'invisible'
    }, this.auth);
    return signInWithPhoneNumber(this.auth, telefone, this.recaptchaVerifier)
  }

  entrarComEmailESenha(email: string, senha: string):  Promise<UserCredential>{
    return signInWithEmailAndPassword(this.auth, email, senha);
  }

  entrar(token: string) {
    localStorage.setItem('__token__', token)
  }

  sair() {
    localStorage.clear();
    return this.auth.signOut();
  }

  recuperarSenha(email: string) {
    return sendPasswordResetEmail(this.auth, email);
  }

  token() {
    return localStorage.getItem('__token__');
  }

}
